import React, { useState, useEffect } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import { VscAzure } from "react-icons/vsc";
import { FaAws } from "react-icons/fa";
import { SiGooglecloud } from "react-icons/si";
import azureRegions from "../../JSON/AzureRegions.json"
import continentFlags from "../../JSON/ContinentIcon.json"
import regionDisplayNames from "../../JSON/AzureDisplayNames.json"
import PricingModalPlaybox from "./PricingModalPlaybox";

const NewPlaybox = () => {
    const { t } = useLanguage();
    const { project_id } = useParams()
    const navigate = useNavigate();
    const [err, setErr] = useState({ message: "", display: false });
    const user_id = sessionStorage.getItem("user_id");
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState("s");
    const [interval, setSubsInterval] = useState("monthly");
    const [provider, setProvider] = useState("azure")
    const [playboxName, setplayboxName] = useState("");
    const [description, setDescription] = useState("");
    const [ops, setOps] = useState("");
    const [showPricingModal, setShowPricingModal] = useState(false)
    const [hasPayment, setPayments] = useState(true);
    const [flexAlreadyPresent, setFlexAlreadyPresent] = useState(false);


    const goBack = () => {
        navigate(`/project_panel/${project_id}/playbox`);
    };

    const NewDb = async () => {
        if (!playboxName.trim()) {
            setErr({ message: "Please provide a name for the database", display: true });
            return;
        }

        if (!description.trim()) {
            setErr({ message: "Please provide a description for the database", display: true });
            return;
        }

        setLoading(true);
        let data = {
            user_id: user_id,
            project_id: project_id,
            playbox_name: playboxName,
            description: description,
            plan: selectedPlan,
            provider: provider,
            interval: interval
        }


        try {
            const response = await fetch("https://backend.erioon.com/create_playbox", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            setLoading(false);
            if (response.ok) {
                const result = await response.json();
                const playbox_id = result.playbox_id;
                navigate(`/project_panel/${project_id}/playbox/${playbox_id}/logs`);
            } else {
                console.error("Error creating db:", response.statusText);
            }
        } catch (error) {
            setLoading(false);
        }
    };



    const fetchUserData = async () => {
        setLoading(true)
        try {
            const response = await fetch('https://backend.erioon.com/get_specific_data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: user_id }),
            });
            setLoading(false)
            if (!response.ok) {
                throw new Error('Failed to fetch user data');
            }

            const data = await response.json();
            const payment_method = data.payment_method

            if (payment_method) {
                setPayments(true)
            } else {
                setPayments(false)
            }

        } catch (error) {
            setLoading(false)
            console.error("Error fetching user data:", error);
        }
    };


    const plans = {
        s: {
            description: "Optimized for small to general-purpose workloads, offering cost-effective performance for light computing tasks and moderate usage scenarios.",
            autoscale: true,
            price: 0.05,
            cpu: "2 vCPU",
            gpu: null,
            memory: "8GB RAM",
        },
        m: {
            description: "A balanced tier for heavier processing and mid-scale applications. Ideal for developers running data-heavy scripts, moderate workloads, or lightweight ML inference without GPU.",
            autoscale: true,
            price: 0.10,
            cpu: "4 vCPU",
            gpu: null,
            memory: "16GB RAM",
        },
        l: {
            description: "Designed for AI workloads, training, and inference. Equipped with powerful GPU acceleration and high memory for machine learning, data processing, and compute-heavy tasks.",
            autoscale: true,
            price: 0.80,
            cpu: "6 vCPU",
            gpu: "NVIDIA V100",
            memory: "112GB RAM",
        }

        // x: {
        //     description: "Latest-gen NVIDIA H100 NVL GPU VM for cutting-edge AI/ML and demanding HPC workloads.",
        //     autoscale: true,
        //     price: 14.41,
        //     cpu: "40 vCPU",
        //     gpu: "H100 NVL",
        //     memory: "320GB RAM",
        // },
    };




    useEffect(() => {
        fetchUserData()
    }, [provider, selectedPlan]);





    if (loadingPage) {
        return <div className="loading_new_db_cont">
            <div className="loading_resources_new">
                <div className="loading_resources_new_main"></div>

            </div>
            <div className="loading_resume_new">
                <div className="loading_resume_new_main">

                </div>
            </div>
        </div>
    }

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title fade-in">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> New playbox
                </p>
                <p className="new_section_main_view_subtitle fade-in">
                    Complete all the fields and release the playbox
                </p>

                {(!hasPayment && selectedPlan != "s") && (
                    <div className="no_payment_method_db fade-in">
                        <p>To proceed, please add a valid payment method to your account.</p>
                        <button className="add_payment_btn" onClick={() => navigate("/control_panel/billing")}><i className="fa-solid fa-plus"></i> Add payment method</button>
                    </div>
                )}

                <div className="new_section_main_input_cont fade-in">
                    <div className="new_section_main_input_container">
                        <p className="db_title">Select playbox tier</p>
                        <div className="db_new_container">
                            {Object.keys(plans).map(planKey => {
                                const plan = plans[planKey];
                                if (flexAlreadyPresent && planKey === "flex") {
                                    return null;
                                }
                                return (
                                    <div
                                        key={planKey}
                                        className={`db_new_container_item ${selectedPlan === planKey ? "db_new_container_item_selected" : ""}`}
                                        onClick={() => setSelectedPlan(planKey)}
                                    >
                                        <div className="db_new_container_item_header">
                                            <p className="db_title">Erioon-{planKey.charAt(0).toUpperCase() + planKey.slice(1)}</p>
                                            <i
                                                className={`fa-regular ${selectedPlan === planKey ? "fa-circle-check" : "fa-circle"}`}></i>
                                        </div>
                                        <div className="db_new_container_item_body">
                                            <p className="db_desc">{plan.description}</p>
                                            <div className="db_dets">
                                                <p>{plan.cpu}</p>
                                                <p>{plan.memory}</p>
                                                {plan.gpu && (
                                                    <p>{plan.gpu}</p>
                                                )}
                                                {/* <p>{plan.backup_storage}</p> */}
                                            </div>
                                        </div>

                                        <div className="db_new_container_item_footer">
                                            {/* <div className="ops_cont">
                                                <p className="ops_cont_title">Operations</p>
                                                <p>{plan.reads_price}</p>
                                                <p>{plan.writes_price}</p>
                                            </div> */}
                                            {plan.price == 0 ? (
                                                <p className="db_footer">Free</p>

                                            ) : (
                                                <p className="db_footer">From $<span>${plan.price.toFixed(2)}</span>/hour</p>

                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>



                    </div>
                    <div className="cost_preview_container">
                        <div className="cost_preview_cont">

                            {plans[selectedPlan].price === 0 ? (
                                <>
                                    <p className="new_section_main_input_hint_title">
                                        Free <span className="price_info" onClick={() => setShowPricingModal(true)}><i className="fa-solid fa-info"></i></span>
                                    </p>
                                    <p className="new_section_main_input_hint_description">
                                        Up to $50 of free compute credit.
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className="new_section_main_input_hint_title">
                                        Price  ${plans[selectedPlan].price.toFixed(2)}/hour <span className="price_info" onClick={() => setShowPricingModal(true)}><i className="fa-solid fa-info"></i></span>
                                    </p>
                                    <p className="new_section_main_input_hint_description">
                                        Billed on the 3rd each month.
                                    </p>
                                </>
                            )}


                        </div>
                        <div className="preview_cont_db">
                            <div className="review_cont">
                                <p className="review_cont_title">Resume for Erioon-{selectedPlan.charAt(0).toUpperCase() + selectedPlan.slice(1)}</p>
                                <p className="review_cont_data"> <span>{plans[selectedPlan].description}</span></p>
                                <p className="review_cont_data">vCPU<span>{plans[selectedPlan].cpu}</span></p>
                                <p className="review_cont_data">Memory <span>{plans[selectedPlan].memory}</span></p>
                                {plans[selectedPlan].gpu && (
                                    <p className="review_cont_data">GPU <span>{plans[selectedPlan].gpu}</span></p>
                                )}

                                <p className="review_cont_data">Auto-scaling <i className={`fa-solid fa-${plans[selectedPlan].autoscale ? "check" : "x"}`}></i></p>

                                {/* {plans[selectedPlan].price != 0 && (
                                    <div className="label_input_section_db">
                                        <label>Payment type</label>
                                        <select
                                            className="review_cont_data_select"
                                            value={interval}
                                            onChange={(e) => setSubsInterval(e.target.value)}
                                        >
                                            <option value="monthly">Monthly</option>
                                            <option value="yearly">Yearly</option>
                                        </select>
                                    </div>
                                )} */}

                                <div className="label_input_section_db">
                                    <label>Playbox name</label>
                                    <input
                                        value={playboxName}
                                        onChange={(e) => setplayboxName(e.target.value)}
                                        placeholder="Play-ML"
                                    />
                                </div>
                                <div className="label_input_section_db">
                                    <label>Description *</label>
                                    <input
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="ML training playbox"
                                        className="description_area_input"
                                    />
                                </div>

                            </div>
                            <ErrorMessage err={err} />
                            <button
                                disabled={!hasPayment && selectedPlan !== "s" || loading}
                                className={`save_btn_db ${(!hasPayment && selectedPlan !== "s") ? "save_btn_db_disabled" : ""}`}
                                onClick={NewDb}
                            >
                                {loading ? <Spinner loading={loading} /> : <><i className="fa-solid fa-plus"></i> Create playbox</>}
                            </button>

                        </div>
                    </div>

                </div>
            </div>
            <PricingModalPlaybox
                show={showPricingModal}
                handleClose={() => setShowPricingModal(false)}
                selectedPlan={selectedPlan}
                plans={plans}
            />
        </div>
    );
};

export default NewPlaybox;
